import Vue from 'vue'
import Vuex from 'vuex'
import sessionModule from './modules/session'
import userModule from './modules/user'
import dashboardModule from './modules/dashboard'
import organizationModule from './modules/organization'
import membershipTemplateModule from '../domains/membershipTemplates/store/membershipTemplate'
import membershipModule from '../domains/memberships/store/membership'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user: userModule,//Auth user data staic while logged in
    dashboard: dashboardModule, //Dashboard data connected to browers session for authenticated user
    session: sessionModule, //Session data connected to browers session for public user
    organization: organizationModule, //Public organization data that user currently viewing
    membershipTemplate: membershipTemplateModule, //Membership templates (reloaded on visit to settings page)
    membership: membershipModule //Membership assignments list (reloaded on visit to memberships page)
  },
  plugins: [
    createPersistedState({//Stored for all interactions in long term storage
      storage: window.localStorage,
      paths: ['user'],
      key: 'my-event-store'
    }),
    //Session - temporary data for session storage
    createPersistedState({
      storage: window.sessionStorage,
      paths: ['organization', 'session', 'dashboard', 'membershipTemplate', 'membership'],
      key: 'my-event-session'
    })
  ]
})
